<div *ngIf="items.length > 0; else noItemsFound">
  <div class="card-container" [ngClass]="viewMode">
    <ng-container *ngIf="viewMode === 'grid'">
      <scale-card
        class="card-style"
        *ngFor="let item of paginatedItems"
        (click)="selectItem(item)"
        (keydown.enter)="selectItem(item)"
        tabindex="0">
        <div class="card-content">
          <div class="card-image-container">
            <img
              class="card-image"
              [src]="item.imageUrl"
              onerror="
                this.onerror = null;
                this.src = '../../../assets/icons/scan_delete.svg';
              "
              alt="{{ item.title }}" />
            <div class="card-text-overlay">
              <h4>{{ item.title }}</h4>
            </div>
          </div>
        </div>
      </scale-card>
    </ng-container>
    <ng-container *ngIf="viewMode === 'list'">
      <div
        class="card-style"
        *ngFor="let item of paginatedItems"
        (click)="selectItem(item)"
        (keydown.enter)="selectItem(item)"
        tabindex="0">
        <div class="list-card">
          <div class="list-card-image-container">
            <img
              class="list-card-image"
              [src]="item.imageUrl"
              onerror="
                this.onerror = null;
                this.src = '../../../assets/icons/scan_delete.svg';
              "
              alt="{{ item.title }}" />
          </div>
          <div class="list-card-content">
            <h2 class="list-card-title">{{ item.title }}</h2>
            <p class="list-card-description">{{ item.description }}</p>
            <div class="list-card-details" style="font-style: italic">
              <div class="list-detail-item">
                <span *ngIf="item.specificPrice">
                  {{ item.specificPrice }}
                </span>
                <span *ngIf="!item.specificPrice">
                  {{ 'rem.properties.label__price_on_request' | translate }}
                </span>
              </div>
              <div
                *ngIf="item.buildingTypes.length > 0"
                class="list-detail-item buildingTypes">
                <span
                  *ngFor="
                    let buildingType of item.buildingTypes;
                    let last = last
                  ">
                  {{ buildingType.name }}<span *ngIf="!last">, </span>
                </span>
              </div>
              <div class="list-detail-item" *ngIf="item.areaSpecification">
                {{ item.areaSpecification }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <mat-paginator
    *ngIf="showPaginator"
    [length]="totalSize"
    [pageSize]="pageSize"
    hidePageSize
    (page)="onPageChange($event)"
    showFirstLastButtons
    [pageIndex]="currentPage">
  </mat-paginator>
</div>
<ng-template #noItemsFound>
  <div class="no-items-found">
    <p>{{ 'rem.properties.label__noItems' | translate }}</p>
  </div>
</ng-template>
